angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsItemZoom', function ($log, $q, EventManager, TeacherDataService, Firebase) {
    return {
        templateUrl: 'template.html',
        scope: {
            selectedClass: '='
        },
        link: function(scope){
            var eventManager = new EventManager('teacherStudentsItemZoom', scope);
            scope.data = {
                resources: [],
                students: [],
                resourceSummaries: [],
                selectedResource: null
            };
            scope.infoMaps = {
                resources: {},
            };
            scope.loadingStatus = {
                done: false,
                failed: false
            };
            var init = function(class_id) {
                scope.loadingStatus.done = false;
                scope.loadingStatus.error = false;
                $q.all([
                    TeacherDataService.getClassStudents(class_id).then(function(students){
                        // $log.log('HERe!!!')
                        scope.data.students = students
                    }),
                    TeacherDataService.getModuleResourceListFlatMap(class_id).then(function(resources){
                        scope.data.resources = _.toArray(resources)
                        scope.infoMaps.resources = resources
                    })
                    ]).then(function(){
                        scope.loadingStatus.done = true;
                        scope.loadingStatus.error = false;
                        scope.data.selectedResource = scope.data.resources[0];
                        loadLogs(class_id)
                    }).catch(function(error){
                        $log.error(error);
                        scope.loadingStatus.done = true;
                        scope.loadingStatus.error = true;
                    });
            }
            var loadLogs = function(class_id) {
                $log.debug('[[teacherStudentsItemZoom]]',['resourceSummary', class_id, scope.data.selectedResource.id].join('/'))
                scope.data.resourceSummaries = Firebase.to3wBoundObject(['resourceSummary', class_id, scope.data.selectedResource.id])
            }
            scope.lookAt = function(){
                $log.debug("[[teacherStudentsItemZoom]] looking at")
                loadLogs(scope.selectedClass.id);
            }
            scope.$watch('selectedClass', function(classroom){
                if (classroom){
                  init(classroom.id);
                }
              })
        }
    }
})
